import { Button } from '@onchainstudios/cryptoys-common-ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { deleteReservation } from '../../lib/cryptoys/drops/reservation';
import StatusPage from '../../components/StatusPage';
import AlphieShrug from '../../img/zoo/AlphieShrug.webp';

function RecaptchaError() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = 'Cryptoys - Recaptcha Error';
    // Cancel the current reservation to make inventory available
    const id = searchParams.get('reservationId');
    if (id) {
      deleteReservation(id, searchParams.get('correlationId'));
    }
    //  We only want this to run once after the page loads
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StatusPage
      waveColor="red"
      legionImage={AlphieShrug}
      contentHeading="This Account Has Been Flagged"
      contentHeadingTag={
        <>
          We’re sorry, something went wrong when verifying your account. To
          regain full access to the platform, please{' '}
          <a
            href="https://support.cryptoys.com/contact/submit-request-HyByIryBq"
            style={{ textDecoration: 'underline' }}
          >
            contact our support team
          </a>{' '}
          at support@cryptoys.com so we can make this right!
        </>
      }
      buttonCont={
        <Button
          variant={'primary'}
          onPress={() => {
            window.location.replace(
              'https://support.cryptoys.com/contact/submit-request-HyByIryBq'
            );
          }}
        >
          Contact Support
        </Button>
      }
    />
  );
}

export default RecaptchaError;
